import { DictionaryUtil } from './../../../utils/DictionaryUtil';
import { SimpleCommand } from './../../../commanding/SimpleCommand';
import { BasicController } from "../BasicController";
import { BasicCommand } from "../commands/BasicCommand";
import { SmartfoxEvent } from "../../event/SmartfoxEvent";
import {getLogger} from "@goodgamestudios/logger";
import {CORE_LOGGER} from "../../../../../index";
const logger = getLogger(CORE_LOGGER);

export class BasicExtensionResponseCommand extends SimpleCommand {
    public execute(commandVars: any = null): void {
        let event: SmartfoxEvent = (<SmartfoxEvent>commandVars);
        let error: number = Number(event.params[0]);
        logger.debug("BasicExtensionResponseCommand: " + event.cmdId + " params: " + event.params);
        if (DictionaryUtil.containsKey(BasicController.commandDict, event.cmdId)) {
            let command: BasicCommand = BasicController.commandDict.get(event.cmdId);
            command.executeCommand(error, event.params);
            BasicController.getInstance().serverMessageArrived(event.cmdId);
        } else {
            logger. warn("UNKNOWN SERVER COMMAND: " + event.cmdId);
        }
    }
}

